export default [
  {
    key: 1,
    value: 1,
    label: '首发素材'
  },
  {
    key: 2,
    value: 2,
    label: '低质素材'
  },
  {
    key: 4,
    value: 4,
    label: '优质素材'
  },
  {
    key: 8,
    value: 8,
    label: '低效素材'
  },
  {
    key: 16,
    value: 16,
    label: '同质化素材风险-挤压严重素材 '
  },
  {
    key: 32,
    value: 32,
    label: '同质化素材风险-排队投放素材'
  },
  {
    key: 128,
    value: 128,
    label: '存在搬运打压风险'
  }
]

export const toutiaoMaterialExcludeLabel = [
  // {
  //   key: 1,
  //   value: 1,
  //   label: '首发素材'
  // },
  {
    key: 2,
    value: 2,
    label: '低质素材'
  },
  // {
  //   key: 4,
  //   value: 4,
  //   label: '优质素材'
  // },
  {
    key: 8,
    value: 8,
    label: '低效素材'
  },
  {
    key: 16,
    value: 16,
    label: '同质化素材风险-挤压严重素材 '
  },
  {
    key: 32,
    value: 32,
    label: '同质化素材风险-排队投放素材'
  },
  {
    key: 128,
    value: 128,
    label: '存在搬运打压风险'
  }
]
